<template>
  <v-container fluid />
</template>

<script>
/* eslint-disable */
import { mapMutations } from "vuex";
import InsurancePricingService from "../../services/salesforce/InsurancePricingService";
import SecurityService from "../../services/salesforce/SecurityService";
import store from "../../store/store";

export default {
  data() {
    return {
      quoteid: "",
      model: null,
    };
  },
  created() {
    this._insurancePricingService = new InsurancePricingService();
    this._securityService = new SecurityService();
  },
  mounted() {
    this.quoteid = this.$route.query.quoteId;
    this.getQuote();
  },
  methods: {
    ...mapMutations(["toogleDialogLoading"]),
    async getQuote() {
      this.toogleDialogLoading(true);
      await this._insurancePricingService
        .LoadQuote(this.quoteid)
        .then((res) => {
          this.loadModel(res.data);
        })
        .catch((reason) => {
          if (
            reason &&
            reason.response &&
            reason.response.data &&
            reason.response.data.message
          ) {
            try {
              let resp = JSON.parse(reason.response.data.message);
              if (resp && resp.length > 0) {
                let msg = resp[0].message.substring(
                  resp[0].message.indexOf("Exception:")
                );
                msg = msg.split("\n")[0].replace("Exception:", "").trim();
                store.commit("showmsg", {
                  text: msg,
                  type: "error",
                });
              } else {
                store.commit("showmsg", {
                  text: "não foi possivel reemitir cotação",
                  type: "error",
                });
              }
            } catch (error) {
              store.commit("showmsg", {
                text: reason.response.data.message,
                type: "error",
              });
            }
          } else {
            store.commit("showmsg", {
              text: "não foi possivel reemitir cotação",
              type: "error",
            });
          }
        })
        .finally(() => {
          this.toogleDialogLoading(false);
        });
    },
    loadModel(data) {
      let modeal = this._insurancePricingService.getRequestModel(data);
      modeal.quoteId = this.quoteid;
      modeal.user.userId = data.userId;
      sessionStorage.setItem("current_quote", JSON.stringify(modeal));
      this.$util.link(
        "comprarProduto",
        { id: "0" },
        { origin: modeal.origin, personType: modeal.persontype }
      );
    },
  },
};
</script>